import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {AnnualPricing, AuditPricing, AuditType, Fee, FEES_ONLY, FeeType, ProductPricing} from "../../../../store/state/order.state";
import {FeeMode} from "../../../../configuration/configuration.model";

export interface AuditTypeFees {
	auditType: AuditType;
	fees: Fee[];
}

@Component({
    selector: 'product-pricing',
    templateUrl: './product-pricing.template.html',
    styleUrls: ['./product-pricing.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProductPricingComponent {

	@Input() pricing: ProductPricing;
	@Input() includeOffsiteDays: boolean;
	@Input() orderUuid: string;


	trackByAnnualPricingFcn = (_index: number, item: AnnualPricing) => item;

	feesFor(annualPricing: AnnualPricing): AuditTypeFees[] {
		const currentMode = this.pricing.pricingAdjustments.fees.some(f => f.mode === FeeMode.PER_EVENT && f.applied) ? FeeMode.PER_EVENT : FeeMode.PER_YEAR;

		return annualPricing.auditPricings.map(ap => ({
			auditType: ap.type,
			fees: this.feesForAuditPricing(ap, currentMode)
		}));
	}

	private feesForAuditPricing(ap: AuditPricing, currentMode: FeeMode): Fee[] {
		return ap.fees.filter(fee => FEES_ONLY.has(fee.type) && (fee.mode === currentMode || fee.mode === null)).map(fee => this.getOverriddenFee(fee.type) ?? fee);
	}

	private getOverriddenFee(type: FeeType): Fee | undefined {
		return this.pricing.pricingAdjustments.fees.find(fee => fee.type === type);
	}
}
